// extracted by mini-css-extract-plugin
module.exports = {"table":"ServerStatusTable_table__uoL2F","header":"ServerStatusTable_header__0CBYQ","body":"ServerStatusTable_body__7brHN","scrolled":"ServerStatusTable_scrolled__1EkL5"};